import { gql } from "@/services/httpAdapter";

export const onCreateSocialMediaReviews = gql`
	subscription onCreateSocialMediaReviews($commissionCycleId: String) {
		onCreateSocialMediaReviews(commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			payPeriodId
			periodStartDate
			periodEndDate
			locationId
			onDemand
			usersReviews {
				positionTitle
				sitesReviews {
					name
					users {
						platformReviewCounts {
							averageRating
							reviewCount
							siteName
							neededResponseTotal
						}
						totalReviews
						user {
							_id
							fullName
							position
							employeeId
							reputationMgmtUserId
						}
					}
				}
			}
			storeReviews {
				averageRating
				reviewCount
				siteName
				neededResponseTotal
				monthToDate
			}
			createdAt
			updatedAt
		}
	}
`;

export const onCreateReviewResponseSummaryByLocation = gql`
	subscription onCreateReviewResponseSummaryByLocation($locationId: String!, $commissionCycleId: String!) {
		onCreateReviewResponseSummaryByLocation(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			locationId
			commissionCycleId
		}
	}
`;

export const onCreateReviewResponseDetailsDialogByLocation = gql`
	subscription onCreateReviewResponseDetailsDialogByLocation(
		$locationId: String!
		$commissionCycleId: String!
		$source: String!
		$siteName: String!
	) {
		onCreateReviewResponseDetailsDialogByLocation(
			locationId: $locationId
			commissionCycleId: $commissionCycleId
			source: $source
			siteName: $siteName
		) {
			locationId
			commissionCycleId
			source
			siteName
		}
	}
`;
